import { Helmet } from "react-helmet";
import PortfolioUploadSection from "./PortfolioUploadSection";
import React from "react";
import Navbar from "components/Navbar";

export default function PortfolioUpload() {
  return (
    <>
      <Helmet>
        <title>Upload Your Portfolio - Begin Tracking</title>
        <meta
          name="description"
          content="Easily upload your portfolio and start managing your assets. Drag & drop functionality makes it simple to keep your investments in check."
        />
      </Helmet>
      <div className="w-full">
        <div className="relative min-h-screen h-auto bg-gray-900_01">
          
          <div className="absolute bottom-0 left-0 right-0 top-0 m-auto flex h-max flex-1 flex-col items-center gap-[58px] py-6 sm:gap-[29px] sm:py-5">
            <div className="container-xs md:px-5">
              <Navbar />
            </div>

            {/* portfolio upload section */}
            <PortfolioUploadSection />
          </div>
        </div>
      </div>
    </>
  );
}
